import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { Search, MapPin } from "lucide-react";

export default function SearchBar({ initialQ = "", initialLocation = "", compact = false, onSearch }) {
  const [q, setQ] = useState(initialQ);
  const [loc, setLoc] = useState(initialLocation);
  const navigate = useNavigate();
  const submit = (e) => {
    e.preventDefault();
    if (onSearch) return onSearch({ q, location: loc });
    const params = new URLSearchParams();
    if (q) params.set("q", q);
    if (loc) params.set("location", loc);
    navigate(`/services?${params.toString()}`);
  };
  const field = "h-12 w-full bg-transparent pl-11 pr-3 text-base text-slate-900 placeholder:text-slate-400 focus:outline-none";
  return (
    <form
      onSubmit={submit}
      data-testid="search-form"
      className={`grid gap-2 rounded-2xl border border-slate-200 bg-white p-2 shadow-[0_12px_40px_-12px_rgba(15,23,42,0.18)] sm:grid-cols-[1.3fr_1fr_auto] ${compact ? "" : "sm:p-2.5"}`}
    >
      <label className="relative flex items-center rounded-xl bg-slate-50 sm:bg-transparent">
        <Search className="absolute left-4 h-5 w-5 text-sky-600" />
        <span className="sr-only">What service do you need?</span>
        <input data-testid="search-service-input" value={q} onChange={(e) => setQ(e.target.value)} placeholder="What service do you need?" className={field} list="service-suggestions" />
        <datalist id="service-suggestions">
          {["Home Cleaning", "Beauty & Wellness", "Photography", "Tutoring", "Home Maintenance", "Events", "Family Services", "Automotive"].map((s) => <option key={s} value={s} />)}
        </datalist>
      </label>
      <label className="relative flex items-center rounded-xl bg-slate-50 sm:border-l sm:border-slate-200 sm:bg-transparent sm:rounded-none">
        <MapPin className="absolute left-4 h-5 w-5 text-teal-600" />
        <span className="sr-only">Where?</span>
        <input data-testid="search-location-input" value={loc} onChange={(e) => setLoc(e.target.value)} placeholder="Where? Suburb, city or postcode" className={field} />
      </label>
      <button data-testid="search-submit-button" type="submit" className="h-12 rounded-xl bg-sky-600 px-7 font-semibold text-white transition-all hover:bg-sky-700 active:scale-[0.98]">
        Search
      </button>
    </form>
  );
}
